import { render } from "./ChangeAffinity.vue?vue&type=template&id=bdc96974&scoped=true"
import script from "./ChangeAffinity.vue?vue&type=script&lang=js"
export * from "./ChangeAffinity.vue?vue&type=script&lang=js"

import "./ChangeAffinity.vue?vue&type=style&index=0&id=bdc96974&scoped=true&lang=scss"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.20.1.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdc96974"]])

export default __exports__